import { useMemo } from "react";
import { observer } from "mobx-react";
import { getProfitColor } from "@utils";
import { useEstimateStructure, ValueCell } from "@tools";
import { useTheme } from "@material-ui/core/styles";

export const MaterialsCompanyProfitabilityCell = observer((cellProps) => {
  const theme = useTheme();
  const structure = useEstimateStructure();
  const { companyBreakdownMaterialProfitability } = structure;
  
  const notApplicable = useMemo(() => (
    companyBreakdownMaterialProfitability === null
  ), [companyBreakdownMaterialProfitability]);
  
  const color = useMemo(() => (
    getProfitColor(companyBreakdownMaterialProfitability, theme)
  ), [companyBreakdownMaterialProfitability, theme]);
  
  return <ValueCell
    size="medium"
    displayContent
    emptyValue={notApplicable} //@todo: check
    value={companyBreakdownMaterialProfitability}
    symbolEnd="%"
    max={99.99}
    style={{color}}
    {...cellProps}
  />
})